import React from 'react';

/**
 * BrandDefaultIcon — sagoma auto + moto del brand NoleggioinCloud (v2).
 *
 * SVG inline: il colore si adatta automaticamente al colore d'accento del cliente
 * tramite fill="currentColor" (eredita CSS `color` dal parent).
 *
 * Utilizzo:
 *   <BrandDefaultIcon className="text-[var(--brand,#2563EB)] h-6 w-auto" />
 *   <BrandDefaultIcon style={{ color: accentColor }} className="h-6 w-auto" />
 */
const BrandDefaultIcon = ({ className = '', style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="9 53 180 85"
    fill="currentColor"
    className={`h-5 sm:h-6 w-auto flex-shrink-0 ${className}`}
    style={style}
    aria-hidden="true"
  >
    <g transform="translate(0.000000,195.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
<path d="M779 1396 c-89 -16 -117 -29 -200 -96 -34 -27 -72 -50 -85 -50 -25 0
-54 -24 -54 -45 0 -8 -18 -19 -42 -25 -62 -16 -188 -70 -225 -97 -54 -39 -77
-116 -75 -253 1 -104 3 -117 23 -132 12 -10 28 -18 37 -18 9 0 29 -12 44 -27
24 -23 39 -28 98 -31 67 -4 71 -3 100 27 36 36 58 38 138 15 38 -11 74 -15
114 -10 57 6 60 5 94 -29 33 -33 38 -35 106 -35 68 0 72 1 103 35 19 19 36 48
40 64 5 22 13 30 37 35 45 9 46 9 58 -29 6 -20 26 -51 45 -70 27 -29 39 -35
74 -35 49 0 96 21 112 52 11 20 16 21 150 15 136 -5 140 -6 160 -31 105 -133
291 1 251 181 -21 92 -70 142 -152 156 -14 2 -5 5 20 6 26 0 51 6 58 13 17 17
15 103 -4 139 -15 29 -14 31 10 54 14 13 26 32 26 43 0 44 -58 57 -85 20 -16
-23 -16 -23 -31 -3 -52 69 -81 81 -129 49 -14 -9 -33 -13 -44 -9 -23 7 -61
-25 -61 -51 0 -20 -42 8 -117 78 -29 27 -79 61 -110 76 -55 26 -66 27 -233 29
-110 1 -203 -3 -251 -11z m441 -35 c20 -6 45 -18 55 -26 16 -13 12 -12 -15 1
-51 25 -131 24 -167 -2 -39 -29 -93 -139 -93 -191 0 -40 -1 -41 -40 -48 -59
-10 -51 -29 10 -23 50 5 50 5 49 -126 -1 -108 -3 -121 -9 -71 -13 107 -45 155
-103 155 -38 0 -78 -35 -98 -85 -16 -41 -39 -162 -39 -206 0 -47 -7 -49 -128
-48 -105 1 -105 4 1 14 79 8 92 21 76 81 -16 59 -35 74 -88 73 -61 -1 -133
-21 -139 -38 -4 -11 3 -13 34 -7 113 19 134 19 149 0 8 -10 15 -31 15 -46 0
-26 -2 -26 -66 -30 -68 -3 -70 -2 -139 46 -22 16 -49 20 -155 24 -128 5 -128
5 -145 -22 -22 -34 -43 -33 -50 2 -16 72 -16 71 25 47 29 -17 50 -19 50 -5 0
5 -19 19 -43 31 -53 27 -49 22 -42 52 8 31 55 45 55 16 0 -10 15 -28 33 -41
28 -20 43 -23 132 -23 126 0 159 14 163 67 5 61 -19 70 -181 66 -119 -3 -137
-1 -146 14 -13 21 -7 40 19 56 18 11 19 10 13 -21 -6 -32 -6 -32 30 9 40 46
94 75 182 98 43 11 70 26 104 58 33 31 37 33 13 8 -17 -20 -32 -39 -32 -43 0
-4 64 -7 143 -8 142 -1 142 -1 72 -23 -79 -25 -125 -48 -172 -84 -55 -41 -37
-45 31 -7 35 19 101 48 147 64 46 16 85 34 87 40 2 6 27 11 55 11 63 0 54 -10
-35 -39 -65 -22 -158 -75 -158 -91 0 -4 -35 -16 -77 -25 -43 -9 -82 -20 -86
-25 -5 -4 2 -19 15 -34 21 -24 30 -26 99 -27 88 -1 109 7 139 56 25 40 20 55
-18 55 -27 0 -27 0 -2 20 13 10 62 31 107 45 45 15 87 33 93 40 19 22 100 178
100 191 0 17 -111 28 -224 21 -91 -5 -91 -5 -21 8 83 16 362 13 415 -4z m-11
-90 c13 -40 14 -61 3 -61 -4 0 -12 25 -18 55 -11 59 -4 61 15 6z m239 -71 c13
-6 22 -14 19 -16 -9 -10 -280 -44 -299 -38 -34 10 -9 21 74 33 46 7 98 14 116
17 39 6 41 22 5 66 -23 29 -21 28 18 -8 24 -23 55 -47 67 -54z m236 39 c22
-26 56 -90 56 -106 0 -2 -31 22 -70 53 -54 45 -67 61 -59 71 19 22 46 15 73
-18z m-120 -5 c24 -9 19 -24 -8 -24 -13 0 -26 7 -30 15 -6 16 10 20 38 9z
m-436 -10 c47 -13 19 -44 -39 -44 -30 0 -38 17 -17 38 13 13 23 14 56 6z m682
-3 c0 -11 -29 -35 -35 -29 -10 9 7 38 21 38 8 0 14 -4 14 -9z m-243 -67 c-7
-7 -57 18 -57 28 0 5 14 1 31 -7 17 -9 29 -19 26 -21z m123 -20 c32 -29 45
-35 66 -30 24 6 26 5 20 -16 -3 -13 -6 -32 -6 -43 0 -16 -4 -14 -27 12 -24 27
-92 73 -108 73 -11 0 -4 -28 15 -65 11 -21 18 -41 16 -43 -3 -2 -21 1 -40 8
-34 11 -35 13 -21 33 8 12 15 36 15 54 0 26 3 31 17 26 12 -5 15 -2 10 10 -9
25 -2 21 43 -19z m-570 2 c-8 -8 -32 -18 -52 -21 -31 -6 -38 -4 -38 8 0 17 18
24 70 26 30 1 32 -1 20 -13z m246 -28 c-18 -42 -29 -45 -50 -13 -18 28 -12 33
56 44 4 0 1 -13 -6 -31z m144 27 c0 -3 -12 -16 -27 -29 -26 -22 -29 -23 -49
-7 -30 22 -13 41 37 41 22 0 39 -2 39 -5z m-237 -42 c-7 -2 -19 -2 -25 0 -7 3
-2 5 12 5 14 0 19 -2 13 -5z m-146 -20 c2 -6 -6 -13 -19 -15 -21 -3 -23 -9
-25 -58 0 -30 4 -77 9 -104 10 -46 9 -51 -12 -68 -12 -10 -25 -18 -29 -18 -3
0 -6 61 -6 135 0 145 0 145 54 142 14 -1 26 -7 28 -14z m95 -33 c9 -16 42 -43
72 -60 31 -18 54 -36 51 -41 -8 -12 -132 79 -163 119 -25 33 -25 33 -1 22 13
-6 32 -24 41 -40z m202 34 c9 -8 16 -18 16 -22 0 -15 -72 -82 -82 -76 -7 4 -5
10 6 16 9 5 16 22 16 38 0 57 16 73 44 44z m291 -24 c3 -6 -1 -10 -9 -10 -8 0
-20 9 -26 21 -11 19 -10 20 9 10 11 -6 23 -16 26 -21z m-364 -16 c16 -10 -1
-24 -30 -24 -16 0 -39 9 -52 21 -24 20 -24 20 24 15 27 -3 53 -8 58 -12z
m-181 -9 c0 -18 -33 -65 -44 -65 -11 0 -12 7 -3 35 7 23 16 35 29 35 10 0 18
-2 18 -5z m447 -22 c29 -9 53 -19 53 -23 0 -3 -12 -15 -28 -27 -71 -52 -95
-119 -76 -208 6 -28 5 -29 -11 -15 -10 8 -27 34 -37 58 -23 51 -33 54 -25 7 5
-32 4 -35 -19 -35 -38 0 -28 -13 34 -42 57 -27 57 -27 -60 -25 -64 1 -120 6
-125 10 -12 13 44 57 73 57 28 0 64 32 64 58 0 9 -9 32 -20 50 -24 39 -20 40
28 7 37 -25 37 -25 50 12 7 21 27 52 44 70 31 32 31 32 5 38 -18 5 -37 1 -59
-12 -34 -20 -53 -51 -24 -40 14 6 16 3 10 -16 -3 -12 -8 -23 -9 -25 -5 -6 -55
30 -55 38 0 18 85 80 108 80 14 0 49 -8 79 -17z m-887 -18 c-21 -22 -31 -25
-99 -25 -92 0 -85 13 19 33 106 21 107 21 80 -8z m500 -25 c0 -6 -14 -10 -30
-10 -28 0 -30 2 -20 20 9 16 15 18 30 10 11 -6 20 -15 20 -20z m-294 3 c25
-26 44 -78 43 -120 -1 -38 -1 -38 -9 8 -19 113 -82 141 -127 56 -26 -49 -24
-188 4 -224 30 -41 70 -38 100 6 13 19 24 48 24 65 2 26 2 27 6 7 6 -30 -32
-113 -59 -130 -29 -18 -62 1 -85 48 -36 74 -13 262 35 291 25 14 49 12 68 -7z
m329 -32 c-3 -6 -11 -11 -17 -11 -6 0 -6 6 2 15 14 17 26 13 15 -4z m105 -48
c-16 -21 -20 -36 -15 -63 4 -25 3 -31 -4 -20 -19 27 -12 85 11 116 19 23 23
25 26 11 2 -9 -6 -29 -18 -44z m-143 -40 c55 -54 76 -80 56 -68 -18 11 -33 23
-33 27 0 4 -7 8 -16 8 -23 0 -114 82 -114 103 0 9 4 17 10 17 5 0 49 -39 97
-87z m543 77 c0 -5 -9 -10 -20 -10 -13 0 -25 -11 -33 -32 -14 -33 -14 -33 -22
1 -5 24 -3 36 6 42 19 12 69 11 69 -1z m-842 -85 c25 6 26 5 10 -11 -30 -30
-48 -11 -46 48 2 53 2 53 5 5 4 -47 5 -49 31 -42z m352 55 c0 -5 -8 -10 -17
-10 -15 0 -16 2 -3 10 19 12 20 12 20 0z m550 -32 c56 -93 16 -231 -75 -254
-43 -11 -93 19 -115 69 -20 43 -26 112 -11 135 4 7 6 -10 4 -40 -10 -134 108
-190 165 -78 28 57 28 85 -3 146 -14 27 -25 50 -25 52 0 1 9 2 20 2 12 0 28
-13 40 -32z m-410 -7 c16 -31 12 -51 -10 -51 -12 0 -22 9 -26 24 -10 43 16 63
36 27z m-104 -16 c12 -30 -2 -35 -25 -11 -24 26 -24 26 -2 26 12 0 24 -7 27
-15z m-441 -15 c3 -5 2 -10 -4 -10 -5 0 -13 5 -16 10 -3 6 -2 10 4 10 5 0 13
-4 16 -10z m242 -82 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2 -13 2 -33 0 -45z
m-207 43 c0 -5 -7 -12 -16 -15 -14 -5 -15 -4 -4 9 14 17 20 19 20 6z m295 -13
c-19 -11 -30 -5 -21 11 4 6 14 7 22 4 15 -5 14 -7 -1 -15z m562 -25 c-3 -10
-5 -2 -5 17 0 19 2 27 5 18 2 -10 2 -26 0 -35z m-689 32 c-11 -11 -68 -23 -68
-15 0 5 6 11 13 13 16 7 62 8 55 2z m-149 -45 c11 -24 11 -24 -3 -6 -9 11 -16
24 -16 30 0 12 5 7 19 -24z m-749 -6 c0 -2 -11 -4 -25 -4 -14 0 -25 4 -25 9 0
4 11 6 25 3 14 -2 25 -6 25 -8z m259 -3 c41 -1 72 -4 68 -7 -3 -4 -77 -3 -163
1 -86 4 -152 10 -146 14 6 4 46 3 89 0 43 -4 111 -8 152 -8z m776 9 c-3 -5
-10 -10 -16 -10 -5 0 -9 5 -9 10 0 6 7 10 16 10 8 0 12 -4 9 -10z m59 -87
c-28 -25 -79 -30 -105 -10 -8 7 -24 26 -33 42 -18 29 -18 30 0 9 11 -12 29
-27 42 -34 31 -15 66 7 90 57 17 36 17 36 24 -3 6 -34 3 -42 -18 -61z m464 63
c14 9 21 11 18 5 -17 -27 -44 -31 -68 -10 -23 21 -23 21 1 5 23 -14 27 -14 49
0z m-1482 -31 c19 -14 19 -14 -2 -15 -12 0 -27 7 -34 15 -17 20 9 21 36 0z
m563 -53 c-5 -2 -21 4 -35 13 -25 16 -25 17 -7 34 17 18 19 17 35 -13 9 -17
12 -33 7 -34z m-453 43 c-11 -8 -25 -15 -31 -15 -6 0 -20 7 -31 15 -17 13 -15
14 31 14 46 0 48 -1 31 -14z"/>
    </g>
  </svg>
);

export default BrandDefaultIcon;
